const PENDING_ORDER_PREFIX = 'bajie_aroma_pending_order_'

export const WECHAT_APP_ID = 'wxb2a56db9cee10d27'

export function isWeixinBrowser (userAgent = '') {
  return userAgent.toLowerCase().includes('micromessenger')
}

export function buildWechatAuthorizeUrl ({ appId, redirectUri, state }) {
  const url = new URL('https://open.weixin.qq.com/connect/oauth2/authorize')
  url.searchParams.set('appid', appId)
  url.searchParams.set('redirect_uri', redirectUri)
  url.searchParams.set('response_type', 'code')
  url.searchParams.set('scope', 'snsapi_base')
  url.searchParams.set('state', state)
  url.hash = 'wechat_redirect'
  return url.toString()
}

export function savePendingOrder (sn, order) {
  try {
    window.localStorage.setItem(`${PENDING_ORDER_PREFIX}${sn}`, JSON.stringify(order))
  } catch (error) {
    // Storage can be unavailable in private browser modes.
  }
}

export function getPendingOrder (sn) {
  try {
    return JSON.parse(window.localStorage.getItem(`${PENDING_ORDER_PREFIX}${sn}`) || 'null')
  } catch (error) {
    return null
  }
}

export function getMatchingPendingOrder (pendingOrder, orderId) {
  if (!pendingOrder || orderId === undefined || orderId === null || orderId === '') return null
  return String(pendingOrder.orderId) === String(orderId) ? pendingOrder : null
}

export function clearPendingOrder (sn) {
  try {
    window.localStorage.removeItem(`${PENDING_ORDER_PREFIX}${sn}`)
  } catch (error) {
    // Storage can be unavailable in private browser modes.
  }
}

export function startWechatPay (data) {
  return new Promise((resolve, reject) => {
    const invoke = () => {
      const dto = data?.wxChatPayDto || {}
      window.WeixinJSBridge.invoke('getBrandWCPayRequest', {
        appId: dto.appid,
        timeStamp: dto.timeStamp,
        nonceStr: dto.nonceStr,
        package: dto.prepayId,
        signType: dto.signType,
        paySign: dto.paySign
      }, result => {
        if (result.err_msg === 'get_brand_wcpay_request:ok') resolve(result)
        else reject(result)
      })
    }

    if (typeof window.WeixinJSBridge === 'undefined') {
      document.addEventListener('WeixinJSBridgeReady', invoke, { once: true })
    } else {
      invoke()
    }
  })
}

export function startAlipay (data) {
  const wrapper = document.createElement('div')
  wrapper.style.display = 'none'
  wrapper.innerHTML = data?.paymentParam || ''
  document.body.appendChild(wrapper)
  const form = wrapper.querySelector('form')
  if (!form) throw new Error('支付宝支付参数无效')
  form.submit()
}
